// extracted by mini-css-extract-plugin
module.exports = {"root":"DetailsActions_root__3OCSx","link":"DetailsActions_link__3upCd"};